module.exports = __webpack_public_path__ + "img/four3Orange.fd7bc030.jpg";